import React, { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { useAtom, useAtomValue } from 'jotai';
import useOlEvent from '@/hooks/useOlEvent';
import { selectValidatedParcelle } from '@/ol/interactions';
import { isDrawingState, validatedParcellesState } from '@/store';
import theme from '@/theme';
import { featureCollection } from '@/utils/geometry/helpers';

export default function InvalidateParcel() {
  const isDrawing = useAtomValue(isDrawingState);

  const onSelect = ({ selected, deselected }) => {
    const selectedIdu = selected.map((s) => s.get('id'));

    const deselectedIduSet = new Set(deselected.map((d) => d.get('id')));

    const updatedSelectIdu = [...selectedIdu, ...selectedValidatedIdu.filter((s) => !deselectedIduSet.has(s))];

    setSelectedValidatedIdu(updatedSelectIdu);
  };

  useOlEvent(selectValidatedParcelle, 'select', onSelect);

  const [selectedValidatedIdu, setSelectedValidatedIdu] = useState([]);

  const [parcellesFC, setParcellesFC] = useAtom(validatedParcellesState);

  const [disableDeletion, setDisableDeletion] = useState(true);

  useEffect(() => {
    if (isDrawing) {
      setDisableDeletion(true);
      return;
    }
    setDisableDeletion(selectedValidatedIdu.length === 0);
  }, [selectedValidatedIdu, isDrawing]);

  const onClick = () => {
    setParcellesFC(
      featureCollection([...parcellesFC.features.filter((feat) => !selectedValidatedIdu.includes(feat.properties.id))]),
    );

    setSelectedValidatedIdu([]);
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: '2px',
        backgroundColor: disableDeletion ? 'grey.50' : theme.palette.secondary.main,
      }}
    >
      <IconButton aria-label="remove-parcel" title="Effacer la sélection" disabled={disableDeletion} onClick={onClick}>
        <DeleteIcon style={{ color: disableDeletion ? null : '#fff' }} />
      </IconButton>
    </Paper>
  );
}
